export var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType[NotificationActionType["AsyncSendFailed"] = 0] = "AsyncSendFailed";
    NotificationActionType[NotificationActionType["AddFavoritePersonaFailedNotification"] = 1] = "AddFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["RemoveFavoritePersonaFailedNotification"] = 2] = "RemoveFavoritePersonaFailedNotification";
    NotificationActionType[NotificationActionType["PeopleHubNotification"] = 3] = "PeopleHubNotification";
    NotificationActionType[NotificationActionType["SkypeNotification"] = 4] = "SkypeNotification";
})(NotificationActionType || (NotificationActionType = {}));
//# sourceMappingURL=NotificationViewState.js.map